import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ActivitiesCircleIconSVG from './icon-activities-circle.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ActivitiesCircleIconSVG {...validProps} />;
}
SvgComponent.iconName = 'activities-circle';

/**
 * @deprecated This is a legacy icon
 */
export const ActivitiesCircleIcon = svgIconWrapper(SvgComponent);
